var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"site-header col-span-9 col-start-4"},[_c('div',{staticClass:"content inline-grid grid-cols-9 col-gap width-full"})])}]

export { render, staticRenderFns }